/**
 * useContextMenu Hook
 *
 * Provides controlled open state for context menus.
 */

import { useContext } from 'react';
import { ContextMenuContext } from './ContextMenuContext';

const useContextMenu = (menuId: string) => {
  const context = useContext(ContextMenuContext);
  
  if (!context) {
    return {
      isControlled: false,
      isOpen: false,
      onOpenChange: undefined,
    };
  }

  const { activeMenuId, openMenu, closeMenu } = context;

  const isOpen = activeMenuId === menuId;

  const onOpenChange = (open: boolean) => {
    if (open) {
      openMenu(menuId);
    } else {
      closeMenu(menuId);
    }
  };

  return { isControlled: true, isOpen, onOpenChange };
};

export { useContextMenu };
